const shorthands = {
    "Admin": "ADMN",
    "Maint.": "MAIN",
    "Finance": "INVO",
    "Mngmt.": "MGMT",
    "Complete" : "COMP",
    "Completed" : "COMP",
    "Resolved" : "RESV",
    "Cleaning" : "CLEA",
    "Closed" : "COMP",
    "Notified":"NOTF",
    "Invoiced":"INVO",
    "Waived":"WAIV",
    "Paid":"PAID",
    "Received":"RCVD",
};
export default shorthands;
